<template>
  <fieldset class="form-group">
    <legend v-if="label" class="col-form-label pt-0">{{ label }}</legend>
    <slot :ariaDescribedby="descriptionId"></slot>
    <small v-if="description" :id="descriptionId" class="form-text text-muted">{{ description }}</small>
  </fieldset>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
let formGroupId = 0
export default defineComponent({
  name: 'BFormGroup',
  props: { label: { type: String, default: '' }, description: { type: String, default: '' } },
  setup() { return { descriptionId: `form-group-description-${++formGroupId}` } }
})
</script>
